import axios from 'axios';

axios.defaults.withCredentials = true

console.log('Axios backend configuration:', {
  baseURL: process.env.REACT_APP_Url,
  withCredentials: axios.defaults.withCredentials
});

// this is just to clean up the code and contains address to our api
export default axios.create({
  baseURL: process.env.REACT_APP_Url
});
